import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { ModalidadeDetail } from '../types'
import { modalidadesRepository } from './modalidadesRepository'

export const useModalidade = makeUseFetchOne<ModalidadeDetail, string>({
  fetch: modalidadesRepository.fetchOne
})
